import * as React from 'react';
import { StyleSheet, View,ScrollView ,ActivityIndicator,Linking,AppState} from 'react-native';
import { Avatar, Appbar ,Text,IconButton,Card,Button,Snackbar } from 'react-native-paper';
import { useFocusEffect } from '@react-navigation/native';

export default function PlansScreen(props) {

  const [connectionToast,setConnectionT]=React.useState(false);
  const [packages,setPackages]=React.useState([]);
  const [refresh,setRefresh]=React.useState(false);

  useFocusEffect(
    React.useCallback(() => {
      console.log('refreshed')
      AppState.addEventListener('change',_handleAppStateChange);

      fetch('https://fitwayz.ir/api/users/credit-packages',
      {
        method:'POST',
        withCredentials: true,
         
        headers:{
          Accept: 'application/json',
          Authorization: 'Bearer ' + global.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([])
      })
      .then(response => response.json()).then(responseJson => {
        setPackages(responseJson);
        console.log(packages)
      })
      .catch(error => {
        setConnectionT(true);
      });

      return () =>{

        AppState.removeEventListener('change',_handleAppStateChange);

      }
    },[])
  );

  const   _handleAppStateChange = (currentAppState) => {
      console.log(currentAppState);
      if(currentAppState=='active'){
        fetch('https://fitwayz.ir/api/users/info',
        {
          method:'POST',
          withCredentials: true,
           
          headers:{
            Accept: 'application/json',
            Authorization: 'Bearer ' + global.token,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify([])
        })
        .then(response => response.json()).then(responseJson => {
          global.credit=responseJson.credit;
          global.creditExpire = responseJson.credit_expires_in;
          setRefresh(!refresh)
        })
        .catch(error => {
          setConnectionT(true);
        });
      }
  }


    return (
      <View style={{height:'100%', backgroundColor:'#ebebeb'}}>

      <Appbar.Header style={{height:50,backgroundColor:'white'}} >
        <Appbar.Action icon="menu" color='#3a3635' onPress={() => props.navigation.openDrawer()} />
        <Appbar.Content title='فیت کارت'/>
        <Appbar.Action style={{marginLeft:'auto'}} icon="arrow-left" color='#3a3635' onPress={() => {props.navigation.goBack()}} />
      </Appbar.Header>

      <View style={styles.container}>

        <View style={{flexDirection:'row'}}>
        <Avatar.Image style={{marginHorizontal:20,backgroundColor:'white',elevation:5}} size={50} source={{uri : global.image.uri}} />
         <View>
         <Text style={{ color:'#3a3635',fontSize:16}}>{global.fname} {global.lname}</Text>
         <View style={{flexDirection:'row'}}>
          <IconButton icon='card-bulleted-outline' style={{margin:-10,marginTop:-8}} />
          <Text style={{marginHorizontal:5}}> {global.credit} تومان</Text>
         </View>
         </View>
        </View>

        <View style={{justifyContent:'center',alignItems:'center',marginRight:25}}>
          <Text style={{fontFamily:'iransansb',fontSize:24}}>{(typeof Number(global.creditExpire) === 'number') ? global.creditExpire : '0'}</Text>
          <Text style={{marginTop:-10}}>روز باقیمانده</Text>
        </View>
 
      </View>

      <View style={styles.container2}>
        <Text numberOfLines={2} style={{ fontSize:12,}}>با فعالسازی هر یک از اشتراک های زیر از اعتبارتان برای رزرو آنلاین سانس ها دلخواه خود با کمترین هزینه استفاده کنید.</Text>
      </View>

      <ScrollView contentContainerStyle={{paddingVertical:10}}>
        {packages.length == 0 ?
        <ActivityIndicator animating size="large" />
      :
      <>
      {packages.map((item)=>{

           return(

          <View style={{marginHorizontal:35,marginVertical:10}}>
          <Card style={{overflow:'hidden'}}>
          <View style={{backgroundColor:'#21706c',justifyContent:'center',alignItems:'center'}}>
              <Text style={{color:'white',margin:4,fontFamily:'iransansb'}}>{item.title}</Text>
          </View>
          <Card.Content style={{flexDirection:'row',justifyContent:'space-between',paddingTop:15,paddingBottom:35,alignItems:'center'}}>
            <View style={{justifyContent:'center',alignItems:'center',marginLeft:30}}>
              <Text style={{fontFamily:'iransansb',fontSize:24}}>{item.price/1000}</Text>
              <Text style={{marginTop:-8}}>هزار تومان</Text>
            </View>

            <View style={{height:'100%', borderColor:'grey',borderWidth:0.3,marginHorizontal:10}}></View>

            <View style={{marginRight:20}}>
              <Text>مدت اعتبار : {item.expiration_period} روز</Text>
              <Text>رزرو تقریبی : {item.estimated_sessions} سانس</Text>
              <Text style={{color:'red'}}>اعتبار هدیه : {(item.credit-item.price)/1000} هزار تومان</Text>
            </View>

          </Card.Content>
          </Card>
            <Button labelStyle={{color:'white'}} style={{backgroundColor:'#2abbc4', marginLeft:'auto',marginRight:'auto',marginTop:-22,width:120}} mode="contained"
             onPress={() => {

              fetch('https://fitwayz.ir/api/users/credit-packages/'+item.id+'/pay',
              {
                method:'POST',
                withCredentials: true,
                 
                headers:{
                  Accept: 'application/json',
                  Authorization: 'Bearer ' + global.token,
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify([])
              })
              .then(response => response.json()).then(responseJson => {
                console.log(responseJson)
                Linking.openURL(responseJson.redirect+'?mobile='+responseJson.mobile+'&token='+responseJson.token)
              })
              .catch(error => {
                setConnectionT(true);
              });

             }}>
              فعالسازی
            </Button>
          </View>
           )

      })}
      </>
      }


        

      </ScrollView>

      <Snackbar
          style={{zIndex:200}}
          visible={connectionToast}
          onDismiss={() => setConnectionT(false)}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>

    </View>
    );
  }

  const styles = StyleSheet.create({
    container: {
      backgroundColor: 'white',
      flexDirection:'row',
      elevation:4,
      paddingBottom:5,
      alignItems:'center',justifyContent:'space-between'
    },
    container2: {
      backgroundColor: '#f2e5d7',
      elevation:4,
      paddingVertical:10,
      paddingHorizontal:20,
    },
  
  });
  